module.exports = __webpack_public_path__ + "assets/11bdc8e56658ad47216a77af5a9176b6.svg";